import React from 'react'

/**
 * Canonical page header used across the dashboard so every page shares the same
 * title size, spacing and surface. Title = text-xl/bold/txt-primary, optional
 * subtitle = text-sm/txt-secondary, optional right-aligned actions slot.
 *
 * Design tokens (the shared system): surfaces use `bg-surface` / `border-border`;
 * text uses `text-txt-primary | -secondary | -tertiary`; the brand accent is
 * `brand-600`. Cards: `rounded-xl bg-surface border border-border`. Prefer these
 * over hard-coded gray/blue classes.
 */
export const PageHeader: React.FC<{
  title: string
  subtitle?: string
  actions?: React.ReactNode
  sticky?: boolean
}> = ({ title, subtitle, actions, sticky }) => (
  <div className={`bg-surface border-b border-border px-6 pt-6 pb-4 ${sticky ? 'sticky top-0 z-10' : ''}`}>
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-txt-primary truncate">{title}</h1>
        {subtitle && <p className="text-sm text-txt-secondary mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  </div>
)
